<template>
  <div>
    <filter-event :range="range" v-model="event"/>
    <filter-checkboxes v-model="selected" :options="options" :enableCount="false"/>
  </div>
</template>

<script>
  import { omitBy, isEmpty, isEqual } from 'lodash'

  export default {
    props: {
      range: {type: Object},
      value: {
        type: Object,
        default: () => {
          return {}
        },
      },
      options: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        event: {
          number: this.value.number || {},
          date: this.value.date || {}
        },
        selected: this.value.valueCheckbox || [],
      }
    },
    computed: {
      preparedInput () {
        return omitBy({
          number: this.event.number,
          date: this.event.date,
          valueCheckbox: this.selected,
        }, isEmpty)
      },
    },
    watch: {
      value (input) {
        this.event = {
          number: input.number || {},
          date: input.date || {}
        }
        this.selected = input.valueCheckbox || []
      },
      preparedInput: {
        handler (newVal, oldVal) {
          if (!isEqual(newVal, oldVal)) {
            this.$emit('input', this.preparedInput)
          }
        },
        deep: true,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-event-service.vue